"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EComponent = void 0;
var EComponent;
(function (EComponent) {
    EComponent["C"] = "C";
})(EComponent || (exports.EComponent = EComponent = {}));
